export function arrayDifference<T>(arr1: T[], arr2: T[]) {
  const uniqueToArr1 = arr1.filter((item) => !arr2.includes(item));
  const uniqueToArr2 = arr2.filter((item) => !arr1.includes(item));
  return [...uniqueToArr1, ...uniqueToArr2];
}
